import React, { useContext } from 'react';
import classNames from 'classnames';

import { DETAIL_MODAL } from 'lib/constants';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { AnalyticsContext } from 'contexts/AnalyticsContext';

import { TooltipStarsProps } from './TooltipStars.types';
import Tipper from 'components/Tipper';
import { zIndex } from 'components/Tipper/Constants';

import { TooltipContent } from './components';

const TooltipStars = ({
	cruise,
	children,
	shipData,
	placement,
	isPanel,
	type,
	container,
	parentClass,
}: TooltipStarsProps) => {
	const tippyClasses = classNames({
		rating: true,
		isPanel,
		...(parentClass && { [parentClass]: true }),
	});
	const { brand }: any = useContext(CruiseSearchContext);
	const { utagRatingTooltip }: any = useContext(AnalyticsContext);

	const tippyProps = (modeTrigger) => {
		const conf = {
			interactive: true,
			animation: 'scale',
			offset: [0, 13],
			appendTo: document.body,
			maxWidth: 330,
			trigger: modeTrigger,
			delay: [100, 100],
			className: tippyClasses,
			isRating: true,
			zIndex: type != DETAIL_MODAL ? zIndex.searchCard : zIndex.detailModal,
		};
		return conf;
	};

	return (
		<Tipper
			placement={placement}
			content={<TooltipContent shipData={shipData} />}
			configuration={tippyProps('click')}
			type='tooltip'
			theme='WithArrow'
			disabled={false}
			utagParams={{
				cruise: cruise,
				container: container,
				brand,
			}}
			utagFunction={utagRatingTooltip}
		>
			{children}
		</Tipper>
	);
};

export default TooltipStars;
